import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "me",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    fetchUserStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchUserSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchUserFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearUser(state) {
      state.data = null;
    },
  },
});

export const { fetchUserStart, fetchUserSuccess, fetchUserFailure, clearUser } =
  userSlice.actions;
export default userSlice.reducer;
